import {
  JobFullfillmentShippingInfoInternalDistribution,
  ShippingAccountTypeEnum,
} from './jobconfigDomain';
import { ShipmentTypeEnum } from './orderDomain';

export interface ShippingAddress {
  addressLine: string;
  city: string;
  countryCode: string;
  email: string;
  isResidential: boolean;
  name: string;
  phoneNumber: string;
  postalCode: string;
  stateProvinceCode: string;
}

export interface Carrier {
  accountNumber: string;
  clientId: string;
  clientSecret: string;
  carrierType: CarrierTypeEnum;
  markupPct: number | null;
  payer: Payer;
  freightEnabled: boolean;
  packageEnabled: boolean;
}

export enum CarrierTypeEnum {
  Nonstandard = 'Nonstandard',
  UPS = 'UPS',
  FedEx = 'FedEx',
  USPS = 'USPS',
  FreightQuote = 'FreightQuote',
}

export interface Payer {
  address: Omit<
    ShippingAddress,
    'email' | 'isResidential' | 'name' | 'phoneNumber'
  >;
  name: string;
  shipperNumber: string;
}

export interface ShippingSplitPayloadShippingItems {
  itemQuantity: number;
  quantity: number;
  shipmentType?: ShipmentTypeEnum;
  carrierType: CarrierTypeEnum | undefined;
  carrierService: string | undefined;
  toAddressLine: string;
  toCity: string;
  toCountryCode: string;
  toName: string;
  toPostalCode: string;
  toStateProvinceCode: string;
  toCompany?: string;
  accountType: ShippingAccountTypeEnum | undefined;
  serialNumber?: number;
  expectedDeliveryDate?: string;
  phoneNumber?: string;
  internalDistribution?: JobFullfillmentShippingInfoInternalDistribution;
  key?: string;
}

export interface ShippingSplitPayload {
  jobId: number;
  shippingItems: ShippingSplitPayloadShippingItems[];
}

export interface ShippingReadDatePayload {
  groupItems: {
    jobIds: number[];
    readyDate: string;
  }[];
}

export interface ShippingConfig {
  id: number;
  orgId: number;
  shipFrom: ShippingAddress;
  carriers: Carrier[];
  version: number;
}

export interface ValidatingAddress {
  addressLine?: string;
  city?: string;
  countryCode?: string;
  postalCode?: string;
  stateProvinceCode?: string;
}

export type PartialShippingAddress = Partial<ShippingAddress>;
export type PartialCarrier = Partial<Carrier>;
export type PartialShippingConfig = Partial<ShippingConfig>;

export enum TrackingStatusEnum {
  DELIVERED = 'DELIVERED',
  EXCEPTION = 'EXCEPTION',
  IN_TRANSIT = 'IN_TRANSIT',
}

export type TrackingDetail = {
  id: number;
  trackingNumber: string;
  city: string | null;
  stateProvince: string | null;
  postalCode: string | null;
  country: string;
  status: string;
  description: string;
  dateTime: string;
  extraInfo: string | null;
};

export type InternalDistribution = {
  display: boolean;
  distributions: string[];
  orgDistributions: OrgDistribution[];
};

export type OrgDistribution = {
  orgId: number;
  orgName: string;
  distributions: string[];
};

export type TrackingInfo = TrackingDetail[];

export enum ShippingMethodNonstandardTypeEnum {
  Will_Call = 'Will_Call',
  Special_Delivery = 'Special_Delivery',
  Internal_Distribution = 'Internal_Distribution',
  Customize = 'Customize',
}
